import { ApiService } from '../../services/api_service';
import * as classNames from 'classnames';
import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { DateneingabeBetrieblicheDaten } from './DateneingabeBetrieblicheDaten';
import { DateneingabeCO2KomplexTabs } from './DateneingabeCO2KomplexTabs';
import { DateneingabeEnergiedaten } from './DateneingabeEnergiedaten';
import { DateneingabeEnergiedatenKomplexTabs } from './DateneingabeEnergiedatenKomplexTabs';
import { DateneingabeErneuerbareEnergienTabs } from './DateneingabeErneuerbareEnergienTabs';
import { DateneingabeFahrzeugeTabs } from './DateneingabeFahrzeugeTabs';
import { DateneingabeMaschinenTabs } from './DateneingabeMaschinenTabs';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { getGewerk } from '../../main/functions/getGewerk';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { StartDashboard } from '../start/StartDashboard';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { TriggerService } from '../../core/trigger/trigger_service';
// import { getBetaLabel } from '../helper';
import { DateneingabeDatencheck } from './DateneingabeDatencheck';
import { DateneingabeAnAbreise } from './DateneingabeAnAbreise';
import { i18n } from '../../i18n/i18n';
import breadcrumbStyle from '../start/BreadcrumbNavigation.less';

interface DateneingabeProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    reloadData: () => void;
    routing: any;
    standortSelected: any;
}

interface DateneingabeState {
    tabIndex: number;
    hideTabs: boolean;
    energiedatenScroll: number;
}

export class Dateneingabe extends React.Component<DateneingabeProps, DateneingabeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxDateneingabe') || 0,
            hideTabs: false,
            energiedatenScroll: 0
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private scrollHandle = -1;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENEINGABE;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_DATENEINGABE;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDateneingabe', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    getHiddenStyle(): React.CSSProperties {
        if (!this.shouldHideTabs()) {
            return {};
        }
        return {
            backgroundImage: 'linear-gradient(#484, #8a8)', color: '#cfc', fontWeight: 'bold', fontSize: 14, paddingLeft: 10,
            marginTop: 0, borderTop: '3px solid #888', fontStyle: 'italic'
        };
    }

    getTabStyle(idx: number): any {
        const tabColor = '#bccae3';
        const tabColorBorder = '#bccae3';
        const tabColorSelected = '#fff';

        return {
            backgroundColor: this.state.tabIndex === idx ? tabColorSelected : tabColor,
            borderColor: tabColorBorder,
            borderRadius: 0,
            display: this.shouldHideTabs() && 'none'
        };
    }

    onChangeGefuehrterModus(value: number): void {
        // console.log('GF Dateneingabe: ', value);
        const { data } = this.props;
        if (Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0) {
            const item: any = {
                tid: data[IDs.ENT_KONFIGURATION][0].tid,
                show_gefuehrter_modus: false,
                gefuehrter_modus: value
            };
            this.dataService.setData(
                IDs.MOD_ETOOL, IDs.ENT_KONFIGURATION, item,
                () => this.triggerService.fire('reload', IDs.ENT_KONFIGURATION)
            );
        }
    }

    render(): JSX.Element {
        const data: any = this.props.data || {};
        const isAdmin = this.apiService.isAdmin();
        const bereichKey = this.apiService.getBereichKey();
        // console.log('U: ', username, isAdmin);
        // this.checkRouting();  // Das soll wohl bestPractice sein, nachdem componentWillReceiveProps ersetzt wurde !
        const gewerk = getGewerk(this.props.data);
        const hasGewerke: boolean = gewerk !== undefined && gewerk > 0;
        const hiddenStyle: React.CSSProperties = this.getHiddenStyle();
        const isCfm: boolean = data.MODUL_SELECTED === 'cfm';
        const isSteuer: boolean = data.MODUL_SELECTED === 'steuer';
        const konfiguration: any = (data[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const disabledCO2Komplex: boolean = isSteuer || !IDs.FLAG_ENABLE_SCOPE3 || konfiguration.co2_fussabdruck_orig !== 1;
        const disabledEnergiedaten: boolean = !isAdmin;
        const disabledErneuerbareEnergien: boolean = isSteuer || konfiguration.daten_erneuerbare_energien_orig !== 1;
        const disabledFahrzeuge: boolean = isSteuer || !hasGewerke || konfiguration.daten_fahrzeuge_orig !== 1 || isCfm;
        const disabledMaschinen: boolean = isSteuer || !hasGewerke || konfiguration.daten_maschinen_orig !== 1 || isCfm;
        const showGefuehrterModus: boolean = konfiguration.gefuehrter_modus_orig === 1;
        const disabledAnAbreise: boolean = isSteuer || bereichKey !== 'kultur';

        const tabDisabled: any = [
            false,
            false,
            disabledCO2Komplex,
            disabledMaschinen,
            disabledFahrzeuge,
            disabledErneuerbareEnergien,
            false,
            disabledEnergiedaten,
            disabledEnergiedaten,
            disabledAnAbreise
        ];

        let selectedIndex: number;
        if (tabDisabled[this.state.tabIndex]) {
            selectedIndex = 0;
            this.setState({ tabIndex: 0 });
        } else {
            selectedIndex = this.state.tabIndex;
        }

        const tabRoutings: Array<any> = [
            { path: RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN },
            { path: RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN_KOMPLEX },
            { path: RoutingIDs.ROUTE_DATENEINGABE_CO2_KOMPLEX },
            { path: RoutingIDs.ROUTE_DATENEINGABE_MASCHINEN_ANLAGEN },
            { path: RoutingIDs.ROUTE_DATENEINGABE_FAHRZEUGE },
            { path: RoutingIDs.ROUTE_DATENEINGABE_ERNEUERBARE_ENERGIEN },
            { path: RoutingIDs.ROUTE_DATENEINGABE_EINGABEKONTROLLE },
            { path: RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN },
            { path: RoutingIDs.ROUTE_DATENEINGABE_DATENCHECK },
            { path: RoutingIDs.ROUTE_DATENEINGABE_AN_ABREISE }
        ];

        return (
            <Tabs
                className='tabs-dateneingabe'
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                selectedIndex={selectedIndex}
                onSelect={
                    (tabIndex, lastIndex, event) => {
                        this.setTabIndex(tabIndex, tabRoutings[tabIndex]);
                        const resetScroll: boolean = tabIndex !== lastIndex && [RoutingIDs.TAB_DATENEINGABE_ENERGIEDATEN_KOMPLEX, RoutingIDs.TAB_DATENEINGABE_CO2_KOMPLEX].indexOf(tabIndex) !== -1;
                        this.setState({ ...(resetScroll && { energiedatenScroll: 0 }) });
                    }
                }
            >
                <TabList
                    // Leistungsproblem: onMouseOver und onMouseOut Events können dazu führen,
                    // dass KomplexFormen sich immer wieder erneuert rendern lassen, deshalb viel CPU-Leistungen verbraucht.
                    // onMouseOver={() => this.setState({ hideTabs: false })}
                    // onMouseOut={() => this.setState({ hideTabs: true })}
                    style={{ display: 'none', minHeight: 20, /*display: 'flex',*/ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', paddingBottom: 1, ...hiddenStyle }}
                >
                    {this.shouldHideTabs() && this.renderHidden()}
                    <Tab disabled={tabDisabled[0]}>
                        {i18n(ApiService.bereichKey === 'kommunalverwaltung' ? 'Stammdaten' : 'Betriebliche Daten', 'tab')}

                    </Tab>
                    <Tab disabled={tabDisabled[1]}>
                        {i18n(ApiService.bereichKey === 'kommunalverwaltung' ? 'Scope 1 und Scope 2' : 'Energiedaten', 'tab')}

                    </Tab>
                    <Tab
                        className={classNames('react-tabs__tab', 'tab-co2')}
                        disabled={tabDisabled[2]}
                    >
                        {i18n(ApiService.bereichKey === 'kommunalverwaltung' ? 'Scope 3' : 'CO₂-Fußabdruck - Scope 3', 'tab')}
                    </Tab>
                    <Tab disabled={tabDisabled[3]}>{i18n('Maschinen / Anlagen / Heizung', 'tab')}</Tab>
                    <Tab disabled={tabDisabled[4]}>{i18n('Fahrzeuge', 'tab')}</Tab>
                    <Tab disabled={tabDisabled[5]}>{i18n('Erneuerbare Energien / Eigenstrom', 'tab')}</Tab>
                    <Tab disabled={tabDisabled[6]}>{i18n('Eingabekontrolle', 'tab')}</Tab>
                    <Tab disabled={tabDisabled[7]}>{i18n('Energiedaten (Einzeln)', 'tab')}</Tab>
                    <Tab disabled={tabDisabled[8]}>{i18n('Datencheck (Entwicklung)', 'tab')}</Tab>
                    <Tab disabled={tabDisabled[9]}>{i18n('An-/Abreise', 'tab')}</Tab>
                    {this.renderTabGefuehrterModus()}
                </TabList>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 0 ? 1 : 0
                    }}
                >
                    <DateneingabeBetrieblicheDaten
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        reloadData={this.props.reloadData}
                        routing={this.props.routing}
                        standortSelected={this.props.standortSelected}
                        gefuehrterModus={showGefuehrterModus}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 1 ? 1 : 0
                    }}
                    onClick={(evt: any) => {
                        const target = (evt || {}).target || {};
                        if (target.nodeName === 'LI' && target.ariaSelected == 'false') {
                            this.setState({ energiedatenScroll: 0 });
                        }
                    }}
                    onScroll={(evt: any) => {
                        if (evt.target.nodeName !== 'DIV') {
                            return;
                        }
                        // Verzögern
                        const value = evt.target.scrollLeft;
                        const handle = window.setTimeout(() => {
                            if (handle === this.scrollHandle) {
                                this.setState({ energiedatenScroll: value });
                            }
                        }, 50);
                        this.scrollHandle = handle;
                    }}
                >
                    <DateneingabeEnergiedatenKomplexTabs
                        data={this.props.data}
                        standortSelected={this.props.standortSelected}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        scrollLeft={this.state.energiedatenScroll}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 2 ? 1 : 0
                    }}
                    onClick={(evt: any) => {
                        const target = (evt || {}).target || {};
                        if (target.nodeName === 'LI' && target.ariaSelected == 'false') {
                            this.setState({ energiedatenScroll: 0 });
                        }
                    }}
                    onScroll={(evt: any) => {
                        if (evt.target.nodeName !== 'DIV') {
                            return;
                        }
                        // Verzögern
                        const value = evt.target.scrollLeft;
                        const handle = window.setTimeout(() => {
                            if (handle === this.scrollHandle) {
                                this.setState({ energiedatenScroll: value });
                            }
                        }, 50);
                        this.scrollHandle = handle;
                    }}
                >
                    <DateneingabeCO2KomplexTabs
                        data={this.props.data}
                        standortSelected={this.props.standortSelected}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        scrollLeft={this.state.energiedatenScroll}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 3 ? 1 : 0
                    }}
                >
                    <DateneingabeMaschinenTabs
                        data={this.props.data}
                        standortSelected={this.props.standortSelected}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 4 ? 1 : 0
                    }}
                >
                    <DateneingabeFahrzeugeTabs
                        data={this.props.data}
                        standortSelected={this.props.standortSelected}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 5 ? 1 : 0
                    }}
                >
                    <DateneingabeErneuerbareEnergienTabs
                        data={this.props.data}
                        standortSelected={this.props.standortSelected}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 6 ? 1 : 0
                    }}
                >
                    {getDefaultHelpIcon('pageEingabekontrolle', 'Hilfe zur Eingabekontrolle', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <StartDashboard
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 7 ? 1 : 0
                    }}
                >
                    <DateneingabeEnergiedaten
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        reloadData={this.props.reloadData}
                        routing={this.props.routing}
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 8 ? 1 : 0
                    }}
                >
                    <DateneingabeDatencheck
                        data={this.props.data}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 9 ? 1 : 0
                    }}
                >
                    <DateneingabeAnAbreise
                        data={this.props.data}
                    />
                </TabPanel>
                <TabPanel />
            </Tabs>
        );
    }

    renderHidden(): JSX.Element {
        return (
            <div>
                Unterbereich:&nbsp;
                {this.state.tabIndex === 0 && 'Betriebliche Daten'}
                {this.state.tabIndex === 1 && 'Energiedaten'}
                {this.state.tabIndex === 2 && 'Ablage'}
            </div>
        );
    }

    renderTabGefuehrterModus(): JSX.Element {
        const showGefuehrterModus: boolean = (this.props.data[IDs.ENT_KONFIGURATION] || [])
            .some((param: any) => param.gefuehrter_modus_orig === 1);
        return (
            <Tab
                disabled
                style={!showGefuehrterModus ?
                    { color: 'white', border: 0, backgroundColor: '#f79646', borderTop: '1px solid #f79646', display: 'unset', marginLeft: 'auto' }
                    : {}
                }
            >
                <div
                    style={{ width: 100, margin: '0 10px', cursor: 'pointer', display: 'inline' }}
                    onClick={() => this.onChangeGefuehrterModus(1)}
                >
                    {i18n('Geführte Eingabe', 'sys')}
                </div>
            </Tab>
        );
    }

    shouldHideTabs(): boolean {
        return false; // Deaktiviert
        // return this.state.hideTabs && this.state.tabIndex <3;
    }
}
